import { OnboardingActionTypes } from './onboarding.types';

export const initialState = {
  startOnboarding: false,
  builderId: null,
  finishedOnboarding: false,
  wizard: {
    started: false,
    finished: false,
    id: null,
  },
  sitebuilder: {
    provisioning: {
      hostingId: null,
      builderAddonId: null,
      loading: false,
      status: null,
    },
    business: {
      loading: false,
      list: [],
    },
    createWithTemplates: {
      templatesList: {
        list: [],
        pagination: {},
        status: null,
        loading: false,
      },
      templatesCategories: {
        list: [],
        status: null,
        loading: false,
      },
      openTemplate: {
        loading: false,
        status: null,
      },
    },
  },
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case OnboardingActionTypes.ONBOARDING_REGISTER_SUCCESS: {
      const { builderId } = action.payload;
      return {
        ...state,
        startOnboarding: true,
        builderId,
      };
    }
    case OnboardingActionTypes.ONBOARDING_REGISTER_FAILURE: {
      return {
        ...state,
        startOnboarding: false,
      };
    }
    case OnboardingActionTypes.ONBOARDING_UPDATE_SUCCESS: {
      return {
        ...state,
        finishedOnboarding: true,
      };
    }
    case OnboardingActionTypes.ONBOARDING_UPDATE_FAILURE: {
      return {
        ...state,
        finishedOnboarding: false,
      };
    }
    case OnboardingActionTypes.WIZARD_REGISTER_SUCCESS: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          started: true,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_REGISTER_FAILURE: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          started: false,
        },
      };
    }
    case OnboardingActionTypes.SET_WIZARD_REGISTER: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          id: action.payload.wizardId,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_UPDATE_SUCCESS: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          finished: true,
          started: action.payload.preventChangeStart ? state.wizard.started : false,
        },
      };
    }
    case OnboardingActionTypes.WIZARD_UPDATE_FAILURE: {
      return {
        ...state,
        wizard: {
          ...state.wizard,
          finished: false,
        },
      };
    }
    case OnboardingActionTypes.RESET_ONBOARDING: {
      return {
        startOnboarding: false,
        finishedOnboarding: false,
        builderId: null,
        wizard: {
          started: false,
          finished: false,
          id: null,
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES: {
      const { categories } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesCategories: {
              ...state.sitebuilder.createWithTemplates.templatesCategories,
              list: categories,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_SUCCESS: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesCategories: {
              ...state.sitebuilder.createWithTemplates.templatesCategories,
              status: 'success',
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesCategories: {
              ...state.sitebuilder.createWithTemplates.templatesCategories,
              status: 'failure',
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_CATEGORIES_LOADING: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesCategories: {
              ...state.sitebuilder.createWithTemplates.templatesCategories,
              loading: action.payload.isLoading,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES: {
      const { templates, pagination } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...state.sitebuilder.createWithTemplates.templatesList,
              list: templates,
              pagination,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.RETURN_SITEBUILDER_TEMPLATES_TO_DEFAULT: {
      // eslint-disable-next-line no-debugger
      debugger;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...state.sitebuilder.createWithTemplates.templatesList,
              list: state.sitebuilder.createWithTemplates.defaultTemplatesList.list,
              pagination: state.sitebuilder.createWithTemplates.defaultTemplatesList.pagination,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_DEFAULT_SITEBUILDER_TEMPLATES: {
      const { templates, pagination } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            defaultTemplatesList: {
              list: templates,
              pagination,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_SUCCESS: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...state.sitebuilder.createWithTemplates.templatesList,
              status: 'success',
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...state.sitebuilder.createWithTemplates.templatesList,
              status: 'failure',
            },
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_TEMPLATES_LOADING: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...state.sitebuilder.createWithTemplates.templatesList,
              loading: action.payload.isLoading,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.RESET_SITEBUILDER_TEMPLATES_STATE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          createWithTemplates: {
            ...state.sitebuilder.createWithTemplates,
            templatesList: {
              ...initialState.sitebuilder.createWithTemplates.templatesList,
            },
          },
        },
      };
    }
    case OnboardingActionTypes.BUSINESS_LIST_BUILDER_REQUEST: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          business: {
            ...state.sitebuilder.business,
            loading: true,
          },
        },
      };
    }
    case OnboardingActionTypes.BUSINESS_LIST_BUILDER_SET: {
      const { data } = action.payload;
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          business: {
            ...state.sitebuilder.business,
            list: data,
            loading: false,
          },
        },
      };
    }
    case OnboardingActionTypes.BUSINESS_LIST_BUILDER_SUCCESS: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          business: {
            ...state.sitebuilder.business,
            loading: false,
            status: 'success',
          },
        },
      };
    }
    case OnboardingActionTypes.BUSINESS_LIST_BUILDER_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          business: {
            ...state.sitebuilder.business,
            loading: false,
            status: 'failure',
          },
        },
      };
    }
    case OnboardingActionTypes.REQUEST_SITEBUILDER_PROVISIONING: {
      const { hostingId } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          provisioning: {
            ...state.sitebuilder.provisioning,
            hostingId,
            loading: true,
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_PROVISIONING: {
      const { builderAddonId } = action.payload;

      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          provisioning: {
            ...state.sitebuilder.provisioning,
            builderAddonId,
            loading: false,
            status: 'success',
          },
        },
      };
    }
    case OnboardingActionTypes.SET_SITEBUILDER_PROVISIONING_FAILURE: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          provisioning: {
            ...state.sitebuilder.provisioning,
            loading: false,
            status: 'failure',
          },
        },
      };
    }
    case OnboardingActionTypes.RESET_SITEBUILDER_PROVISIONING: {
      return {
        ...state,
        sitebuilder: {
          ...state.sitebuilder,
          provisioning: {
            ...initialState.sitebuilder.provisioning,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default onboardingReducer;
